import { SymbolListComponent } from './symbol-list/symbol-list.component';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import { map, filter,switchMap } from 'rxjs/operators';
import {FXResponse} from '../../models/response.model';
import {MapUtils} from '../../shared/utils/mapper';
import {APP_CONFIG} from '../../shared/common/config';
import {standardizeParam} from '../../shared/utils/helper';
import {GroupConfig, IBTradeSetting, TraderCampaign} from '../../models/founder.model';
import { fromFetch } from 'rxjs/fetch';
import { Affiliate } from 'src/app/models/affiliate.model';
@Injectable()
export class AffiliateService {

  constructor(private http: HttpClient) {
  }

  getListIBSetting(params: any): Observable<FXResponse<[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.FOUNDER}/ib-allow-groups?${standardizeParam(params)}`;
    return this.http.get(url).pipe(
      map((res: any) => {
        const response = new FXResponse<[]>().deserialize(res);
        response.paging = res.data.paging;
        response.data = res.data.users.map((kyc: any) =>
          MapUtils.deserialize(IBTradeSetting, kyc)
        );
        return response;
      })
    );
  }
  getListIbRanking(){
    const url = `${APP_CONFIG.BASE_API_LINK.BONUS}/ib-ranking`;
    return this.http.get(url).pipe(
      map((res: any) => {
        const response = new FXResponse<[]>().deserialize(res);
        return response;
      })
    );
  }
  getIbRankingValidator(){
    const url = `${APP_CONFIG.BASE_API_LINK.BONUS}/ib-ranking/validator`;
    return this.http.get(url).pipe(
      map((res: any) => {
        const response = new FXResponse<[]>().deserialize(res);
        return response;
      })
    );
  }
    updateIBRanking(data): Observable<FXResponse<[]>> {
      return this.http
        .put(`${APP_CONFIG.BASE_API_LINK.BONUS}/ib-ranking`, data)
        .pipe(
          map((res: any) => {
            const response = new FXResponse<any>().deserialize(res);
            return response;
          })
        );
  }
  addConfigIbSetting(data): Observable<FXResponse<[]>> {
    return this.http
      .post(`${APP_CONFIG.BASE_API_LINK.FOUNDER}/ib-allow-groups`, data)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          return response;
        })
      );
  }
  updateConfigIbSetting(data): Observable<FXResponse<[]>> {
    return this.http
      .put(`${APP_CONFIG.BASE_API_LINK.FOUNDER}/ib-allow-groups`, data)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          return response;
        })
      );
  }

  getListTraderSetting(params: any): Observable<FXResponse<[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.FOUNDER}/trader-allow-groups?${standardizeParam(params)}`;
    return this.http.get(url).pipe(
      map((res: any) => {
        const response = new FXResponse<[]>().deserialize(res);
        response.paging = res.data.paging;
        response.data = res.data.users.map((kyc: any) =>
          MapUtils.deserialize(IBTradeSetting, kyc)
        );
        return response;
      })
    );
  }

  addConfigTraderSetting(data): Observable<FXResponse<[]>> {
    return this.http
      .post(`${APP_CONFIG.BASE_API_LINK.FOUNDER}/trader-allow-groups`, data)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          return response;
        })
      );
  }


  getListIBCampaign(params): Observable<FXResponse<[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.FOUNDER}/ib-campaigns?${standardizeParam(params)}`;
    return this.http.get(url).pipe(
      map((res: any) => {
        const response = new FXResponse<[]>().deserialize(res);
        response.paging = res.data.paging;
        response.data = res.data.ib_campaigns;
        return response;
      })
    );
  }

  getListTraderCampaign(params): Observable<FXResponse<[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.FOUNDER}/trader-campaigns?${standardizeParam(params)}`;
    return this.http.get(url).pipe(
      map((res: any) => {
        const response = new FXResponse<[]>().deserialize(res);
        response.paging = res.data.paging;
        response.data = res.data.trader_campaigns;
        return response;
      })
    );
  }

  getGroupConfigs(params: any): Observable<FXResponse<[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.FOUNDER}/groups-configs?${standardizeParam(params)}`;
    return this.http.get(url).pipe(
      map((res: any) => {
        const response = new FXResponse<[]>().deserialize(res);
        response.paging = res.data.paging;
        response.data = res.data.group_configs.map((config: any) =>
          MapUtils.deserialize(GroupConfig, config)
        );
        return response;
      })
    );
  }

  getIBGroupConfigs(params: any): Observable<FXResponse<[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.FOUNDER}/ib-groups?${standardizeParam(params)}`;
    return this.http.get(url).pipe(
      map((res: any) => {
        const response = new FXResponse<[]>().deserialize(res);
        response.paging = res.data.paging;
        response.data = res.data.group_configs.map((config: any) =>
          MapUtils.deserialize(GroupConfig, config)
        );
        return response;
      })
    );
  }

  getTraderCampaign(params: any): Observable<FXResponse<[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.FOUNDER}/trader_campaign_id?${standardizeParam(params)}`;
    return this.http.get(url).pipe(
      map((res: any) => {
        const response = new FXResponse<[]>().deserialize(res);
        response.data = res.data.map((campaign: any) =>
          MapUtils.deserialize(TraderCampaign, campaign)
        );
        return response;
      })
    );
  }

  getAffiliates(params?: any): Observable<FXResponse<Affiliate[]>> {
    return this.http
      .get(`${APP_CONFIG.BASE_API_LINK.IB}?${standardizeParam(params)}`)
      .pipe(
        map((res: any) => {
          const data = res.data.ib_list;
          const response = new FXResponse<Affiliate[]>().deserialize(res);
          response.paging = res.data.paging;
          response.data = data.map((affiliate: any) =>
            MapUtils.deserialize(Affiliate, affiliate)
          );
          return response;
        })
      );
  }

  getTradeAllowGroups(): Observable<FXResponse<[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.FOUNDER}/trader-allow-groups`;
    return this.http.get(url).pipe(
      map((res: any) => {
        const response = new FXResponse<[]>().deserialize(res);
        response.paging = res.data.paging;
        response.data = res.data.group_configs.map((config: any) =>
          MapUtils.deserialize(GroupConfig, config)
        );
        return response;
      })
    );
  }

  updateConfig(data): Observable<FXResponse<[]>> {
    return this.http
      .post(`${APP_CONFIG.BASE_API_LINK.FOUNDER}/groups-configs`, data)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          return response;
        })
      );
  }

  createTradeCampaign(data: any): Observable<FXResponse<[]>> {
    return this.http
      .post(`${APP_CONFIG.BASE_API_LINK.FOUNDER}/trader-campaigns`, data)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          return response;
        })
      );
  }

  createIBCampaign(data: any): Observable<FXResponse<[]>> {
    return this.http
      .post(`${APP_CONFIG.BASE_API_LINK.FOUNDER}/ib-campaigns`, data)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          return response;
        })
      );
  }

  getIBListSymbols(params): Observable<FXResponse<[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.FOUNDER}/list-symbol?${standardizeParam(params)}`;
    return this.http.get(url).pipe(
      map((res: any) => {
        const response = new FXResponse<any>().deserialize(res);
        return response;
      })
    );
  }

  getIBListTrading(params): Observable<FXResponse<[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.BONUS_SETTING}/ib-ranking/symbol-settings?${standardizeParam(params)}`;
    return this.http.get(url).pipe(
      map((res: any) => {
        const response = new FXResponse<any>().deserialize(res);
        return response;
      })
    );
  }

  updatePointTrading(params): Observable<FXResponse<[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.BONUS_SETTING}/ib-ranking/symbol-settings/`+params.id;
    params = MapUtils.serialize(params);
    return this.http.put(url, params).pipe(
      map((res: any) => {
        const response = new FXResponse<any>().deserialize(res);
        return response;
      })
    );
  }

  updateIBRewardSymbol(params): Observable<FXResponse<[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.FOUNDER}/symbol`;
    params = MapUtils.serialize(params);
    return this.http.put(url, params).pipe(
      map((res: any) => {
        const response = new FXResponse<any>().deserialize(res);
        return response;
      })
    );
  }

  resetIBRewardSymbol(symbolId): Observable<FXResponse<[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.FOUNDER}/set-default`;
    return this.http.put(url, {
      symbol_id: symbolId
    }).pipe(
      map((res: any) => {
        const response = new FXResponse<any>().deserialize(res);
        return response;
      })
    );
  }

  importTradingVolumnCSV(formData){
    const url = `${APP_CONFIG.BASE_API_LINK.BONUS_SETTING}/ib-ranking/symbol-settings`;
    let myHeaders = new Headers();
    let tọken = localStorage.getItem('access_token')
    myHeaders.append("Authorization", 'Bearer ' + tọken);
    return fromFetch(url, {
      method: 'POST',
      headers: myHeaders,
      body: formData,
      redirect: 'follow'
    }).pipe(
      switchMap(res => {
        if (res.ok) {
          return res.json();
        }
      })
    )
  }

  importIBRewardCSV(formData){
    const url = `${APP_CONFIG.BASE_API_LINK.FOUNDER}/upload-ib-reward-setting`;
    let myHeaders = new Headers();
    let tọken = localStorage.getItem('access_token')
    myHeaders.append("Authorization", 'Bearer ' + tọken);
    return fromFetch(url, {
      method: 'POST',
      headers: myHeaders,
      body: formData,
      redirect: 'follow'
    }).pipe(
      switchMap(res => {
        if (res.ok) {
          return res.json();
        }
      })
    )
  }

  createMT5Account(data): Observable<FXResponse<[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.FOUNDER}/create-account`;
    return this.http
      .post(url, data)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          return response;
        })
      );
  }

  updateTradingVolume(params): Observable<FXResponse<[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.BONUS}/ib-ranking/point-conversion`;
    return this.http.put(url, params).pipe(
      map((res: any) => {
        const response = new FXResponse<any>().deserialize(res);
        return response;
      })
    );
  }

  getTradingVolume(): Observable<FXResponse<[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.BONUS}/ib-ranking/point-conversion`;
    return this.http.get(url).pipe(
      map((res: any) => {
        const response = new FXResponse<any>().deserialize(res);
        return response;
      })
    );
  }
}
